import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	LinearProgress,
	Chip,
} from "@mui/material";
import React, { useRef } from "react";
import useInfiniteScroll from "../../hooks/useInfiniteScroll";
import dashboardServices from "../../services/hoa-dashboard-api-service";
import { HoverMouse } from "./hover-mouse";

const toolbar = 64;
const filterComponent = 102;
const padding = 32;
const tableHeader = 48;
const responsiveHeight = toolbar + filterComponent + padding + tableHeader + 1;

// Make % from each column width
const tableColumnWidth = ["7%", "6%", "15%", "15%", "15%", "10%", "7%", "10%", "10%", "5%"];

const PendingSourceTable = ({
	loading,
	headers,
	columns,
	fetchData,
	tagType,
	setLoading,
	selectedValues,
	updateSelectedValues,
	activeMenu,
	changeActiveMenu,
	updateView,
	downloadDocument,
}: any) => {
	const tableRef = useRef(null);
	const numberOfRows = Math.ceil((window.innerHeight - responsiveHeight) / 60);

	const { isFetching, rows, count } = useInfiniteScroll(
		tableRef,
		fetchData,
		tagType,
		numberOfRows
	);

	const tbodyHeight = `${window.innerHeight - responsiveHeight + 48}px`;

	const validateColumnValue = (column: any, row: any) => {
		if (column === "status") {
			return (
				<p style={{ backgroundColor: "#E8F5EC", padding: "8px", width: "84px" }}>
					{row[column]}
				</p>
			);
		} else if (column === "sourceType") {
			if (row[column] === "Mail") {
				return (
					<Chip label={row[column]} color="primary" sx={{ backgroundColor: "#FFD54F" }} />
				);
			}
			return <Chip label={row[column]} color="success" sx={{ backgroundColor: "#9575CD" }} />;
		} else if (column === "organization") {
			return row[column]?.name || "N/A";
		} else if (column === "sendTo" || column === "sendFrom") {
			if (row.sourceType === "Mail") {
				return row[column]?.name;
			}
			return row[column] || "N/A";
		} else {
			return row[column] || "N/A";
		}
	};

	const onIconBtnClick = async (e: any, data: any, option: any, tagType?: any) => {
		updateSelectedValues({});
		if (tagType === "PendingSource") {
			e.stopPropagation();
			updateSelectedValues(data);
			await extractData(data);
			changeActiveMenu(activeMenu, true, data.objectId, -1, option);
			updateView("assign");
		}
	};

	const extractData = async (data: any) => {
		setLoading(true);
		if (!data.objectId && !data.sourceType) {
			setLoading(false);
			return;
		}
		if (data.sourceType === "Email") {
			const emailData = await dashboardServices.getEmailById(data.objectId);
			updateSelectedValues(emailData.data);
		} else if (data.sourceType === "Mail") {
			const mailData = await dashboardServices.getMailById(data.objectId);
			updateSelectedValues(mailData.data);
		}
		setLoading(false);
	};

	return (
		<>
			{isFetching || loading ? <LinearProgress style={{ height: "2px" }} /> : null}
			<TableContainer
				component={Paper}
				sx={{ boxShadow: "none" }}
				ref={tableRef}
				style={{ height: tbodyHeight, width: "calc( 100% + 2px)" }}
			>
				<Table sx={{ width: "2000px" }}>
					<TableHead>
						<TableRow>
							{headers.map((header: string) => (
								<TableCell
									id="table-header-row"
									align="left"
									key={header}
									width={tableColumnWidth[headers.indexOf(header)]}
								>
									{header}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map((row: any, index: number) => (
							<TableRow
								key={row.name}
								id="table-body-tableRow"
								className="table-body"
							>
								{columns.map((column: any) => (
									<TableCell
										align="left"
										key={column}
										className={`table-body-container`}
										width={tableColumnWidth[columns.indexOf(column)]}
										onClick={(e) => onIconBtnClick(e, row, "assign", tagType)}
									>
										{column === "hover" ? (
											<HoverMouse
												data={row}
												downloadDocument={downloadDocument}
												onIconBtnClick={onIconBtnClick}
											/>
										) : (
											validateColumnValue(column, row)
										)}
									</TableCell>
								))}
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default PendingSourceTable;
